export class PaginatorHelper {

  constructor(
    public campoOrdenacao = 'id',
    public tamanhoPagina = 10,
    public indicePrimeiroRegistroPagina = 0,
    public tipoOrdenacao = 'asc') {
  }


}
